import type { AxiosError } from 'axios';
import {
  type MusinsaStandardResponse,
  standardResponseErrorToData,
} from './musinsaStandardResponse';

export const executeStandardRequest = async <D, Error = void>(
  requestFn: () => Promise<MusinsaStandardResponse<D>>,
) => {
  try {
    const response = await requestFn();
    return response.data;
  } catch (error) {
    return Promise.reject(standardResponseErrorToData<Error>(error as AxiosError<Error>));
  }
};
